import { ReactNode } from 'react'
import { useBlocker } from 'react-router'

/**
 * Component wrapper for react-router `useBlocker` hook where the blocker is passed as a render prop. Use the hook when possible.
 * @constructor
 */
export default function Blocker(props: {
  shouldBlock: Parameters<typeof useBlocker>[0]
  children: (blocker: ReturnType<typeof useBlocker>) => ReactNode
}) {
  const blocker = useBlocker(props.shouldBlock)

  return props.children(blocker)
}
